module.exports = __webpack_public_path__ + "static/recent-2-5e2f26bce36095284a85ebf02aeedebf.jpg";